export default __webpack_public_path__ + "static/media/logo.dd0f8178.svg";